<!-- SIDEBAR CONTENT -->

<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}" *ngIf="newOrder.vouchers.length>0 || newOrder.items.length>0">
    <div class="nav material2">
        <div class="nav-item text-center" style="font-size: 26px; font-weight: bold;">
            <span *ngIf="!isInvoice">{{'Receipt'|translate}}</span>
            <span *ngIf="isInvoice">{{'Invoice'|translate}}</span>
        </div>

        <table class="table">
            <tbody>
                <tr class="nav-item" *ngFor="let item of newOrder.items">
                    <td>
                        {{item.product.name}}
                        <span *ngIf="item.priceGross<item.priceGrossBeforeDiscount && item.priceGrossBeforeDiscount>0">
                            <br/><b>{{'Before discount'|translate}}: {{item.priceGrossBeforeDiscount * item.quantity}}</b>
                        </span>
                        <div>
                            <button (click)="changeProductQuantity(item, -1)" mat-raised-button color="accent">-</button>
                            <input (input)="setProductQuantity(item, $event.target.value)" matInput style="width: 50px; line-height: 36px; text-align: center;" [ngModel]="item.quantity"/>
                            <a (click)="changeProductQuantity(item, 1)" mat-raised-button color="accent">+</a>
                        </div>
                    </td>
                    <td valign="top" style="text-align: right; padding-right: 5px;">
                        {{item.priceGross * item.quantity}}
                    </td>
                </tr>
                <tr class="nav-item" *ngFor="let item of newOrder.vouchers">
                    <td>
                        {{item.voucherTemplate.name}}
                        <span *ngIf="item.priceGross!=item.priceGrossBeforeDiscount && item.priceGrossBeforeDiscount>0">
                            <br/><b>{{'Before discount'|translate}}: {{item.priceGrossBeforeDiscount * item.quantity}}</b>
                        </span>
                        <div>
                            <button (click)="changeVoucherQuantity(item, -1)" mat-raised-button color="accent">-</button>
                            <input (input)="setVoucherQuantity(item, $event.target.value)" matInput style="width: 50px; line-height: 36px; text-align: center;" [ngModel]="item.quantity"/>
                            <a (click)="changeVoucherQuantity(item, 1)" mat-raised-button color="accent">+</a>
                        </div>
                    </td>
                    <td valign="top" style="text-align: right; padding-right: 5px;">{{item.priceGross * item.quantity}}</td>
                </tr>
            </tbody>
        </table>

        <hr/>

        <div class="nav-item text-center">
            <button (click)="showDiscountsDialog()" mat-raised-button [color]="'accent'" *ngIf="newOrder.priceGross!=newOrder.priceGrossBeforeDiscount && newOrder.priceGrossBeforeDiscount>0">
                <s>{{newOrder.priceGrossBeforeDiscount}} PLN</s>
            </button>
            <br *ngIf="newOrder.priceGross!=newOrder.priceGrossBeforeDiscount && newOrder.priceGrossBeforeDiscount>0"/>
            <span style="font-weight: bold; font-size: 26px;">{{newOrder.priceGross}} PLN</span>
        </div>

        <hr/>

        <div class="nav-item text-center">
<!--            <b>{{'Payment method'|translate}} </b><br/><br/>-->
            <button title="karta" mat-raised-button [color]="newOrder.paymentMethod==='karta'?'primary':'accent'" (click)="changePaymentMethod('karta')"><mat-icon>credit_card</mat-icon></button>&nbsp;&nbsp;
            <button title="gotówka" mat-raised-button [color]="newOrder.paymentMethod==='gotówka'?'primary':'accent'" (click)="changePaymentMethod('gotówka')"><mat-icon>money</mat-icon></button>&nbsp;
            <button mat-raised-button color="accent" (click)="showSelectCustomerDialog()"><mat-icon>people</mat-icon></button>
        </div>
        <hr/>
        <div class="nav-item text-center">
            <button mat-raised-button color="accent" (click)="showSplitPaymentDialog()"><mat-icon>call_split</mat-icon> {{'Split payment'|translate}}</button>&nbsp;&nbsp;
        </div>
        <hr/>
        <div class="nav-item text-center">
            <button mat-raised-button color="accent" (click)="showConfirmBillPrintDialog()"><mat-icon>print</mat-icon> {{'Print bill'|translate}}</button>&nbsp;&nbsp;
        </div>
<!--        <hr *ngIf="customer"/>-->
<!--        <div class="nav-item text-center" *ngIf="customer">-->
<!--            <button mat-raised-button color="accent" (click)="saveBill()" *ngIf="!savingOpenBill">-->
<!--                <mat-icon>save</mat-icon>-->
<!--                {{'Save bill'|translate}}-->
<!--            </button>&nbsp;&nbsp;-->
<!--            <button mat-raised-button color="accent" *ngIf="savingOpenBill" disabled>-->
<!--                <mat-icon *ngIf="savingOpenBill">autorenew</mat-icon>-->
<!--                {{'Saving'|translate}}-->
<!--            </button>&nbsp;&nbsp;-->
<!--        </div>-->
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
